export default {
  setEmail: (payload: string) => ({ type: 'login/setEmail', payload }) as const,
  setEmailDelivered: (payload: boolean) =>
    ({ type: 'login/setEmailDelivered', payload }) as const,
  setEmailInvalid: (payload: boolean) =>
    ({ type: 'login/setEmailInvalid', payload }) as const,
};
